<div class="custom-table-wrapper">
  <p-table #dt class="custom-table-container" [value]="data.items" [rowHover]="true" [first]="first" [scrollable]="true"
    [stripedRows]="false" [resizableColumns]="true" [columnResizeMode]="'expand'"
    (onColResize)="handleColResize($event)" [size]="'small'" [autoLayout]="true" [showGridlines]="true">
    <!-- -->
    <!-- Table caption -->
    <ng-template pTemplate="caption">

      <div class="d-flex justify-content-between align-items-center caption-container flex-column flex-sm-row">
        <div class="d-flex align-items-center justify-content-between gap-2">
          <div *ngIf="listStoreConsolidated.itemsSelect.length > 0">
            <form [formGroup]="formSelect">
              <div class="d-flex align-items-center caption-container">
                <span class="px-2 fw-bold">Tipo Informe:</span>
                <p-select formControlName="select" class="select-input" [options]="listStoreConsolidated.itemsSelect"
                  optionLabel="label" (onChange)="filterStoreConsolidated($event.value)" placeholder="Filtrar"
                  [showClear]="false" appendTo="body" size="small">
                  <ng-template let-option #item>
                    <span>{{ option.label }}</span>
                  </ng-template>
                </p-select>
              </div>
            </form>
          </div>
          <div *ngIf="listDifferences.itemsSelect.length > 0">
            <form [formGroup]="formSelect">
              <div class="d-flex align-items-center caption-container">
                <span class="px-2 fw-bold">Diferencia:</span>
                <p-select formControlName="select" class="select-input" [options]="listDifferences.itemsSelect"
                  optionLabel="label" (onChange)="filterDifferences($event.value)" placeholder="Filtrar"
                  [showClear]="false" appendTo="body" size="small">
                  <ng-template let-option #item>
                    <span>{{ option.label }}</span>
                  </ng-template>
                </p-select>
              </div>
            </form>
          </div>
          <div *ngIf="listRemissionOrderState.itemsSelect.length > 0">
            <form [formGroup]="formSelect">
              <div class="d-flex align-items-center caption-container">
                <span class="pe-2 fw-bold">Tipo Informe:</span>
                <p-select formControlName="select" class="select-input" [options]="listRemissionOrderState.itemsSelect"
                  optionLabel="label" (onChange)="filterRemissionOrderState($event.value)" placeholder="Filtrar"
                  [showClear]="false" appendTo="body" size="small">
                  <ng-template let-option #item>
                    <span>{{ option.label }}</span>
                  </ng-template>
                </p-select>
              </div>
            </form>
          </div>
          <div *ngIf="listOrderType.itemsSelect.length > 0">
            <form [formGroup]="formSelect">
              <div class="d-flex align-items-center caption-container">
                <span class="pe-2 fw-bold">Tipo:</span>
                <p-select formControlName="select" class="select-input" [options]="listOrderType.itemsSelect"
                  optionLabel="label" (onChange)="filterOrderType($event.value)" placeholder="Filtrar"
                  [showClear]="false" appendTo="body" size="small">
                  <ng-template let-option #item>
                    <span>{{ option.label }}</span>
                  </ng-template>
                </p-select>
              </div>
            </form>
          </div>
          <div *ngIf="listShowView.itemsSelect.length > 0">
            <form [formGroup]="formSelect">
              <div class="d-flex align-items-center caption-container">
                <span class="ps-1 pe-2 fw-bold">Desplegar:</span>
                <p-select formControlName="select" class="select-input" [options]="listShowView.itemsSelect"
                  optionLabel="label" (onChange)="filterShowDeployBy($event.value)" placeholder="Desplegar"
                  [showClear]="false" appendTo="body" size="small">
                  <ng-template let-option #item>
                    <span>{{ option.label }}</span>
                  </ng-template>
                </p-select>
              </div>
            </form>
          </div>
          <!-- checkbox actions -->
          <ng-container *ngFor="let checkBox of checkBoxAction; let actionIndex = index">
            <div class="p-1">
              <p-button *ngIf="selectedItems.length > 0"
                label="{{ checkBox.label }} ({{countSelectedItems > 0 && countSelectedItems}})" filled
                [style]="getButtonStyle(checkBox)" class="checkbox-action-button" icon="{{ checkBox.icon }}"
                size="small" (onClick)="bulkAction(checkBox.action)" />
            </div>
          </ng-container>
          <!-- Select and close modal -->
          <ng-container *ngIf="showButtonAdd && isSelectedItems && checkBoxAction.length === 0 && showCheckbox">
            <app-custom-button [id]="'add-selected'" [icon]="'pi pi-plus-circle'" [width]="'8.5rem'"
              [label]="'Agregar' + (countSelectedItems > 0 ? ' (' + countSelectedItems + ')' : '')"
              [severity]="'success'" (onClick)="returnSelectedData()"></app-custom-button>
          </ng-container>
          <div *ngIf="filteredFilters.length " class="d-flex align-items-center caption-container">
            <div>
              <span class="pe-1 fw-bold">Filtros aplicados:</span>
            </div>
            <div class="filter-container d-flex align-items-center gap-2 flex-wrap">
              <p-chip *ngFor="let filter of filteredFilters" [label]="getLabelName(filter.propertyName)"
                [removable]="true" (onRemove)="removeChip(filter)" />
            </div>
          </div>
        </div>
        <div *ngIf="showImport || showRecover" class="d-flex justify-content-between align-items-center p-1 gap-3">
          <app-custom-button *ngIf="showImport" [title]="'Importar'" [label]="'Importar'" [severity]="'success'"
            [width]="'5.5rem'" [icon]="'pi pi-file-import'" (onClick)="importFile()"></app-custom-button>

          <app-custom-button *ngIf="showExport" [title]="'Exportar'" [label]="'Exportar'" [severity]="'success'"
            [width]="'5.5rem'" [icon]="'pi pi-file-export'" (onClick)="exportFile()"></app-custom-button>

          <ng-content select="[tableExtraButtons]"></ng-content>

          <app-custom-button *ngIf="showRecover" [title]="'Recuperar'" [label]="'Recuperar'" [severity]="'primary'"
            [width]="'6.5rem'" [icon]="filtersChanged ? 'pi pi-spin pi-refresh' :'pi pi-refresh'" [variant]="undefined"
            [ngClass]="filtersChanged ? 'pulse-button' : ''" (onClick)="recoverData()"></app-custom-button>
        </div>
      </div>
    </ng-template>

    <!-- Table header -->
    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="showCheckbox">
          <ng-container *ngIf="isMultipleSelect; else singleSelect">
            <div style="width: 2.2rem; text-align:center">
              <p-checkbox binary="true" class="custom-checkbox" [ngModel]="isAllSelected()"
                (onChange)="toggleSelectAll($event.checked)">
              </p-checkbox>
            </div>
          </ng-container>

          <ng-template #singleSelect>
            Seleccionar
          </ng-template>
        </th>
        <ng-container *ngFor="let col of headers; let colIndex = index">
          <th pResizableColumn [attr.data-frozen]="isColumnFrozen(col.propertyName)"
            [ngClass]="{'frozen-column': isColumnFrozen(col.propertyName)}"
            [ngStyle]="getHeaderStyle(col.propertyName, col.inputType)" (dblclick)="onHeaderDblClick($event, colIndex)">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <span>{{col.label}}</span>
              </div>
              <div class="buttons-container" *ngIf="col.propertyName !== 'reg'">
                <button pButton type="button" [icon]="getLockIcon(col.propertyName)" (click)="toggleColumnLock(col)"
                  class="p-button-text p-button-sm p-button-rounded" [disabled]="isFrozenDisabled(col.propertyName)">
                </button>

                <button pButton type="button" [icon]="getSortIcon(col.propertyName)"
                  (click)="toggleSort(col.propertyName)" class="p-button-text p-button-sm p-button-rounded">
                </button>
              </div>
            </div>
          </th>
        </ng-container>
        <th *ngIf="actions.length" class="column-action" pResizableColumn [attr.data-frozen]="actionFrozen"
          alignFrozen="right" [ngClass]="{'frozen-column-right': actionFrozen}" style="min-width: 30px;">
          Acciones
        </th>
      </tr>

      <!-- Filters -->
      <ng-container *ngIf="showRecover">
        <tr>
          <!-- Agrega th en "Reg" para alinear los filtros-->
          <th *ngIf="showCheckbox"></th>
          <ng-container *ngFor="let col of headers">
            <th [ngStyle]="getHeaderStyle(col.propertyName, col.inputType)">
              <div>
                <form [formGroup]="formFilters">
                  <app-custom-filters *ngIf="col.isFilter" [control]="getFormControl(col.propertyName)"
                    [controlAlter]="getFormControlAlter(col.propertyName)" [field]="col.propertyName"
                    [inputType]="col.inputType" [itemsSelect]="col.itemsSelect"
                    [placeholder]="'Buscar por ' + col.label" (onChangeFilter)="filter($event)">
                  </app-custom-filters>
                </form>
              </div>
            </th>
          </ng-container>
          <th *ngIf="actions.length" class="column-action" [attr.data-frozen]="actionFrozen" alignFrozen="right"
            [ngClass]="{'frozen-column-right': actionFrozen}" style="min-width: 30px;">
          </th>
        </tr>
      </ng-container>

    </ng-template>

    <!-- Empty message -->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr *ngIf="!filtersChanged">
        <td style="width: 2rem; text-align:center" *ngIf="selectedItems.length > 0"></td>
        <td [attr.colspan]="headers.length + (actions.length ? 1 : 0) + (showCheckbox ? 1 : 0)" class="text-center">
          <div class="not-data p-4 flex-column align-items-center justify-content-center">
            <i class="pi pi-info-circle text-primary mb-3" style="font-size: 2rem"></i>
            <p class="m-0 text-secondary fs-6">No hay datos disponibles</p>
          </div>
        </td>
      </tr>
      <tr *ngIf="filtersChanged">
        <td [attr.colspan]="headers.length + (actions.length ? 1 : 0)" class="px-6 py-10 text-center">
          <div class="not-data p-4 flex-column justify-content-center">
            <i class="pi pi-exclamation-circle text-warning mb-3" style="font-size: 2rem"></i>
            <p class="m-0 text-secondary fs-6">Los filtros han cambiado. Haz clic en "Recuperar" para actualizar
              los datos.</p>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Table body -->
    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr [pSelectableRow]="null" (click)="handleRowClick(item, $event)" (dblclick)="onRowDoubleClick(item)"
        [ngClass]="getRowClasses(item)">
        <td style="width: 2.2rem; text-align:center" *ngIf="showCheckbox">
          <!-- Caso RadioButton -->
          <p-radioButton *ngIf="radioButton" name="radioGroup" [value]="item" [(ngModel)]="selectedRadioItem"
            (onClick)="toggleRadio(item)">
          </p-radioButton>
          <!-- Caso Checkbox múltiple -->
          <p-checkbox *ngIf="!radioButton && isMultipleSelect" [binary]="true" [ngModel]="isItemChecked(item)"
            (onChange)="handleCheckboxChange(item, $event.checked)" class="custom-checkbox">
          </p-checkbox>
          <!-- Caso Selección simple con botón -->
          <button *ngIf="!radioButton && !isMultipleSelect" pButton type="button" [icon]="'pi pi-plus-circle'"
            class="p-button-text p-button-sm p-button-rounded" (click)="handleSingleSelectionChange(item)">
          </button>
        </td>
        <ng-container *ngFor=" let col of headers; let colIndex=index">
          <td [attr.data-frozen]="isColumnFrozen(col.propertyName)" [ngClass]="getColumnClasses(item, col)"
            [ngStyle]="getHeaderStyle(col.propertyName, col.inputType)">
            <ng-container [ngSwitch]="col.inputType.toLowerCase()">

              <ng-container *ngSwitchCase="'image'">
                <div class="d-flex justify-content-center align-items-center">
                  <p-image *ngIf="item[col.propertyName] && getImageBlobUrl(item[col.propertyName])"
                    [src]="getImageBlobUrl(item[col.propertyName])!" [alt]="item.articleName || 'Imagen'"
                    [imageStyle]="{ 'border-radius': '.25rem', 'margin': '2px' }" width="60" height="60" />
                  <span *ngIf="!item[col.propertyName] || !getImageBlobUrl(item[col.propertyName])"
                    class="text-muted">-</span>
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                {{ col.propertyName === 'reg' ? getColumnIndex(rowIndex) : transform(col.inputType,
                item[col.propertyName]) }}
              </ng-container>
            </ng-container>
          </td>
        </ng-container>

        <td *ngIf="actions.length" class="action-buttons" [attr.data-frozen]="actionFrozen" alignFrozen="right"
          [ngClass]="{'frozen-column-right': actionFrozen}">
          <button *ngFor="let action of actions" pButton type="button" [icon]="action.icon" [pTooltip]="action.label"
            class="p-button-text p-button-sm p-button-rounded" (click)="executeAction(action, item)"></button>
        </td>
      </tr>

    </ng-template>

    <!-- Table footer -->
    <ng-template *ngIf="!filtersChanged" pTemplate="footer">
      <tr>
        <td style="width: 2.2rem; text-align:center" *ngIf="showCheckbox"></td>
        <ng-container *ngFor="let col of headers; let colIndex = index">
          <td [attr.data-frozen]="isColumnFrozen(col.propertyName)"
            [ngClass]="{'frozen-column': isColumnFrozen(col.propertyName)}"
            [ngStyle]="getHeaderStyle(col.propertyName, col.inputType)">
            <div class="ps-1 text-end" *ngIf="data.totals && data.totals.length > 0">
              <strong>{{ getTotalValue(col.propertyName, colIndex) }}</strong>
            </div>
          </td>
        </ng-container>

        <td *ngIf="actions.length" [attr.data-frozen]="actionFrozen" alignFrozen="right"
          [ngClass]="{'frozen-column-right': actionFrozen}">
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Paginator -->
  <p-paginator #paginator class="{{classPaginator}}" (onPageChange)="changePage($event)" [first]="first"
    [rows]="data.pageSize" [showCurrentPageReport]="true" [totalRecords]="data.totalItems" dropdownAppendTo="body"
    [rowsPerPageOptions]="paginatorArray" currentPageReportTemplate="{currentPage} de {totalPages}" />
</div>